import merge from 'lodash/merge';
import { getPixelClientMeta, logInfo } from '@embed/helpers';
import { pruneNilValues } from '../utils';
import { sendBeaconPixel } from './beacon';
import { sendGetPixel } from './get';
export const sendPixelTracking = (args) => {
    var _a, _b, _c;
    const { url: path, data = {}, host } = args;
    const mergedData = pruneNilValues(merge({}, getPixelClientMeta(), data));
    if (typeof window !== 'undefined' &&
        ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window._fwn) === null || _a === void 0 ? void 0 : _a.console) === null || _b === void 0 ? void 0 : _b.instance) === null || _c === void 0 ? void 0 : _c.isOpen)) {
        logInfo('Pixel', path, mergedData);
    }
    try {
        return sendBeaconPixel({ path, data: mergedData, host });
    }
    catch (err) {
        return sendGetPixel({ path, data: mergedData, host });
    }
};
